/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Search_Role_PlaceholderInputs */

const en_salary_search_role_placeholder = /** @type {(inputs: Salary_Search_Role_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Software Engineer`)
};

const de_salary_search_role_placeholder = /** @type {(inputs: Salary_Search_Role_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z.B. Software Engineer`)
};

const fr_salary_search_role_placeholder = /** @type {(inputs: Salary_Search_Role_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex. Software Engineer`)
};

const es_salary_search_role_placeholder = /** @type {(inputs: Salary_Search_Role_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ej. Software Engineer`)
};

const it_salary_search_role_placeholder = /** @type {(inputs: Salary_Search_Role_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`es. Software Engineer`)
};

const nl_salary_search_role_placeholder = /** @type {(inputs: Salary_Search_Role_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bijv. Software Engineer`)
};

const pl_salary_search_role_placeholder = /** @type {(inputs: Salary_Search_Role_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`np. Software Engineer`)
};

const fi_salary_search_role_placeholder = /** @type {(inputs: Salary_Search_Role_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`esim. ohjelmistokehittäjä`)
};

const da_salary_search_role_placeholder = /** @type {(inputs: Salary_Search_Role_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`f.eks. softwareudvikler`)
};

const sv_salary_search_role_placeholder = /** @type {(inputs: Salary_Search_Role_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`t.ex. mjukvaruutvecklare`)
};

/**
* | output |
* | --- |
* | "e.g. Software Engineer" |
*
* @param {Salary_Search_Role_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_search_role_placeholder = /** @type {((inputs?: Salary_Search_Role_PlaceholderInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Search_Role_PlaceholderInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_search_role_placeholder(inputs)
	if (locale === "fr") return fr_salary_search_role_placeholder(inputs)
	if (locale === "es") return es_salary_search_role_placeholder(inputs)
	if (locale === "it") return it_salary_search_role_placeholder(inputs)
	if (locale === "nl") return nl_salary_search_role_placeholder(inputs)
	if (locale === "pl") return pl_salary_search_role_placeholder(inputs)
	if (locale === "fi") return fi_salary_search_role_placeholder(inputs)
	if (locale === "da") return da_salary_search_role_placeholder(inputs)
	if (locale === "sv") return sv_salary_search_role_placeholder(inputs)
	return en_salary_search_role_placeholder(inputs)
});